var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('a',{staticClass:"back-btn",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.onClickBack($event)}}},[_c('i',{staticClass:"fas fa-chevron-left"}),_vm._v(" "+_vm._s(_vm.$tc("back"))+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }